const STREET_NUMBER = ["street_number", "premise"];
const STREET = ["route", "sublocality"];
const STREET2 = ["sublocality_level_1"];
const STREET3 = [
  "sublocality_level_2",
  "sublocality_level_3",
  "sublocality_level_4",
  "sublocality_level_5"
];
const SUBURB = "locality";
const CITY = "administrative_area_level_2";
const STATE = "administrative_area_level_1";
const COUNTRY = "country";
const POSTCODE = "postal_code";
const UNKNOWN = "";

const getSuburb = addressComponents => {
  let result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(address => {
      return address.types.find(type => type === SUBURB);
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

const getCity = addressComponents => {
  let result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(address => {
      return address.types.find(type => type === CITY);
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

const getState = addressComponents => {
  let result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(address => {
      return address.types.find(type => type === STATE);
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

const getCountry = addressComponents => {
  let result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(address => {
      return address.types.find(type => type === COUNTRY);
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

const getPostalCode = addressComponents => {
  let result = UNKNOWN;
  if (addressComponents && addressComponents.length) {
    result = addressComponents.find(address => {
      return address.types.find(type => type === POSTCODE);
    });
    result = result && result.short_name ? result.short_name : result;
  }
  return result;
};

module.exports = { getSuburb, getCity, getState, getCountry, getPostalCode };



// WEBPACK FOOTER //
// ./utils/Address.js